<div *ngIf="!showContent" class="loading-spinner">
    <mat-spinner></mat-spinner>
</div>

<ng-container *ngIf="showContent">
    <!-- <mat-tab-group>
        <mat-tab label="Package Details"> -->

    <div class="container">
        <div class="row"></div>
        <ag-grid-angular style="height: 320px; margin:10px" [columnDefs]="packageColumnDefs"
            [defaultColDef]="defaultColDef" [rowData]="packages" [autoGroupColumnDef]="autoGroupColumnDef"
            [detailCellRenderer]="detailCellRenderer" [detailRowHeight]="280" [masterDetail]="true"
            [rowGroupPanelShow]="rowGroupPanelShow" [class]="themeClass" (gridReady)="onGridReady($event)">
        </ag-grid-angular>

        <button mat-raised-button color="primary" style="margin:10px" (click)="openModal('move')">Move Package</button>
        <button mat-raised-button color="primary" style="margin:10px" (click)="openModal('delete')">Remove Package</button>
    </div>

    <!-- <div [formGroup]="package_form">
                <div class="container">
                    <div>
                        <h2>PACKAGE PROFILE</h2>
                        <div class="grid-container">
                            <mat-form-field>
                                <mat-label>Warehouse Name</mat-label>
                                <input matInput formControlName="warehouse_name">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Contact Organization</mat-label>
                                <input matInput formControlName="contact_organization">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Package Name</mat-label>
                                <input matInput formControlName="package_name">
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <h2>PACKAGE METRICS</h2>
                        <div class="grid-container">
                            <mat-form-field>
                                <mat-label>Length</mat-label>
                                <input matInput formControlName="length">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Width</mat-label>
                                <input matInput formControlName="width">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Height</mat-label>
                                <input matInput formControlName="height">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Weight</mat-label>
                                <input matInput formControlName="weight">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div> -->

    <!-- </mat-tab>
        <mat-tab label="Product Details">

            <ag-grid-angular *ngIf="gridReady" style="height: 220px; margin:10px" [columnDefs]="productColumnDefs"
                [defaultColDef]="defaultColDef" [rowData]="products" [class]="themeClass"
                (gridReady)="onGridReady($event)">
            </ag-grid-angular>

        </mat-tab>
        <mat-tab label="Lading Details">

            <div [formGroup]="ladings_form">
                <div class="container-ladings">
                    <div>
                        <h2>ORDER INFO</h2>
                        <div class="grid-container">
                            <mat-form-field>
                                <mat-label>Order No.</mat-label>
                                <input matInput formControlName="alternate_reference">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>BOL No.</mat-label>
                                <input matInput formControlName="lading_number">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>PRO Bill</mat-label>
                                <input matInput formControlName="pro_bill">
                            </mat-form-field>
                            <ng-container *ngIf="lading_uuid">
                                <a mat-raised-button color="primary" [routerLink]="['/full-order-details', lading_uuid]">View More Details</a>
                            </ng-container>

                            <ng-container *ngIf="!lading_uuid">
                                <button mat-raised-button color="primary" disabled>View More Details</button>
                            </ng-container>
                        </div>
                    </div>
                    <div>
                        <h2>CONTACT DETAILS</h2>
                        <div class="grid-container">
                            <mat-form-field>
                                <mat-label>Shipper Name</mat-label>
                                <input matInput formControlName="shipper_name">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Consignee Name</mat-label>
                                <input matInput formControlName="consignee_name">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Carrier Name</mat-label>
                                <input matInput formControlName="carrier_name">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Customer Name</mat-label>
                                <input matInput formControlName="customer_name">
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <h2>DELIVERY DETAILS</h2>
                        <div class="grid-container">
                            <mat-form-field>
                                <mat-label>Pickup City</mat-label>
                                <input matInput formControlName="shipper_locality">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Delivery City</mat-label>
                                <input matInput formControlName="consignee_locality">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Pickup Date</mat-label>
                                <input matInput formControlName="load_start">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Delivery Date</mat-label>
                                <input matInput formControlName="load_end">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>

        </mat-tab>
    </mat-tab-group> -->
</ng-container>